export default "__VITE_ASSET__yahxaxXu__"